import { Chip } from '@mui/material';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiReq from 'core/api';
import DataTablePage, { DataTableColumn } from 'components/DataTablePage';
import { Role, RolePermission } from 'types';
import { useSnackbar } from 'components/GlobalSnackbar';

const RolesPage = () => {
  const navigate = useNavigate();
  const [roles, setRoles] = useState<Role[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const showSnackbar = useSnackbar();

  useEffect(() => {
    loadRoles();
  }, []);

  const loadRoles = async () => {
    try {
      setIsLoading(true);
      const data = await apiReq<Role[]>('roles/all');
      setRoles(data || []);
    } catch (error) {
      console.error('Ошибка загрузки ролей:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCreateRole = () => {
    navigate('/roles/create');
  };

  const handleEditRole = (role: Role) => {
    navigate(`/roles/edit/${role.id}`);
  };

  const handleDeleteRole = async (role: Role) => {
    try {
      await apiReq(`roles/delete`, 'DELETE', { id: role.id });
      showSnackbar({ message: 'Роль успешно удалена', severity: 'success' });
      loadRoles();
    } catch (error) {
      if (error instanceof Error) {
        showSnackbar({ message: error.message, severity: 'error' });
      } else {
        showSnackbar({ message: 'Ошибка удаления роли', severity: 'error' });
      }
    }
  };

  const columns: DataTableColumn[] = [
    {
      key: 'title',
      label: 'Название',
    },
    {
      key: 'name',
      label: 'Код',
    },
    {
      key: 'description',
      label: 'Описание',
    },
    {
      key: 'permissions',
      label: 'Разрешения',
      render: (value: unknown) => {
        const permissions = value as RolePermission[];
        return (
          <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
            {permissions.map((permission) => (
              <Chip
                key={permission.title}
                label={permission.title}
                size="small"
                variant="outlined"
              />
            ))}
          </div>
        );
      },
    },
  ];

  return (
    <DataTablePage<Role>
      title="Роли"
      columns={columns}
      data={roles}
      isLoading={isLoading}
      onCreate={handleCreateRole}
      onEdit={handleEditRole}
      onDelete={handleDeleteRole}
      createButtonText="Создать роль"
      emptyMessage="Роли не найдены"
    />
  );
};

export default RolesPage;
